<template>
  <m-form
    :title="title"
    :items="items"
    :cols="cols"
    :canSubmit="canSubmit"
    :canDelete="false"
    :showClearBtn="false"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :showSubmitAndClearBtn="false"
    :show-navigation-btns="false"
    :showActions="item.id != undefined"
    @click:row="setItem"
    @submit="submit"
  >
    <template #header-btns v-if="this.usage == 'factor'">
      <v-btn
          depressed
          class="secondary rounded-lg white--text mr-1 "
          :to="`/panel/defaultAccounts/factor`"
      >حساب
      </v-btn>
      <v-btn
          depressed
          class="primary rounded-lg white--text mr-1 "
          @click="clearForm"
      >پی نوشت
      </v-btn>
      <v-btn
          depressed
          class="secondary rounded-lg white--text mr-1 "
          :to="`/panel/factor/expenses/buy`"
      >هزینه های خرید
      </v-btn>
      <v-btn
          depressed
          class="secondary rounded-lg white--text mr-1 "
          :to="`/panel/factor/expenses/sale`"
      >هزینه های فروش
      </v-btn>
    </template>

    <template #default>
      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label="عنوان" v-model="item.name" disabled />
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="متن" v-model="item.value" :disabled="!isEditing" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import DefaultTextApiMixin from "@/views/panel/defaultTexts/api";

export default {
  mixins: [MFormMixin, DefaultTextApiMixin],
  props: {
    usage: {
      required: true,
    },
  },
  data() {
    return {
      item: {},
      baseUrl: "home/defaultTexts",
      cols: [
        {
          text: "عنوان",
          value: "name",
        },
        {
          text: "متن",
          value: "value",
          type: 'text'
        },
      ],
    };
  },
  computed: {
    title() {
      return "پیشفرض های فاکتور > پی نوشت";
    },
    items() {
      return this.defaultTexts.filter((o) => o.usage == this.usage);
    },
  },
  methods: {
    getData() {
      this.getDefaultTexts(true);
    },
  },
};
</script>